import { Div, Img, router } from '@codesuma/baseline'
import style from './index.module.css'
import { MenuIcon } from 'components/menu-icon'
import { PlusIcon } from 'components/plus-icon'

// Home page header: hamburger menu + centered app logo + round add button
export const HomeHeader = () => {
    const base = Div()
    base.addClass(style.base)

    const menuBtn = MenuIcon()
    menuBtn.el.onclick = () => router.goto('/menu')
    base.append(menuBtn)

    const logo = Img('/images/logo.svg')
    logo.addClass(style.logo)
    base.append(logo)

    const addBtn = PlusIcon()
    addBtn.el.onclick = () => router.goto('/add')
    base.append(addBtn)

    return base
}
